import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { isEqual } from 'underscore';
import { useSelector } from 'react-redux';
import { makeGetEvent } from 'sportsbook-events-selector';
import selectors from 'SportsbookOverview/redux/selectors';
import EventDetailContainer from './event_detail_container';

const EventDetailRedux = ({
  eventId,
  externalMarketProvided,
  externalMarket,
}) => {
  // Stablish redux selector to extract the event for the given event id
  const getEvent = useMemo(makeGetEvent, []);
  const event = useSelector((state) => getEvent(state, { eventId }), isEqual);
  // --------------------------------------------

  // TODO: This is a temp workaround to support this component on places
  // that have completely different ways of fetching the active market for
  // an event, and sadly, the outright event needs a market to extract the
  // place term descriptions of the market and add them tto the even title
  // (business requirements)
  //
  // A solution for this wiill be to provide a market id instead of a market
  // or using 'SportsbookOverview' makeGetEventMarket selector, this way
  // we could just query the global markets redux state in order to extract
  // the required info.
  let market;

  if (externalMarketProvided) {
    market = externalMarket;
  } else {
    // Stablish redux selector to extract the market for the given event id
    const getMarket = useMemo(selectors.makeGetEventMarket, []);
    market = useSelector((state) => getMarket(state, { eventId }), isEqual);
    // --------------------------------------------
  }
  // ------------------------------------------------------------------

  return (
    <EventDetailContainer
      eventId={eventId}
      event={event || {}}
      market={market}
    />
  );
};

EventDetailRedux.propTypes = {
  eventId: PropTypes.number.isRequired,
  externalMarketProvided: PropTypes.bool,
  externalMarket: PropTypes.instanceOf(Object),
};

EventDetailRedux.defaultProps = {
  externalMarketProvided: false,
  externalMarket: undefined,
};

export default EventDetailRedux;
